import {ProductUpdate, SeenProductUpdatesRequest} from 'app_api/product_updates/types';
import {getProjectId} from 'common/report/util';
import {apiClient} from 'common/util/api-client';

import {appApiUrl} from '../utils';

const BASE_URL = appApiUrl(`product_updates`);

export function getProductUpdates(): Promise<ProductUpdate[]> {
  const projectId = getProjectId();
  const projectIdParam = projectId ? `project_id=${getProjectId()}` : ``;
  return apiClient.get<ProductUpdate[]>(BASE_URL + `?${projectIdParam}`, null, {importance: `low`});
}

export function markProductUpdatesAsSeen(updateIds: number[]): Promise<void> {
  const data: SeenProductUpdatesRequest = {seen: updateIds};
  return apiClient.post(`${BASE_URL}/seen`, data);
}
